import React from "react";
import { Route } from "react-router-dom";
import { BenefisCard } from "./BenefisCard";
import { BenefisEditDialog } from "./benefis-edit-dialog/BenefisEditDialog";
import { BenefisUIProvider } from "./BenefisUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { RoleChecker } from "../../../RoleChecker";
import { BenefisDeleteDialog } from "./benefis-delete-dialog/BenefisDeleteDialog";

export function BenefisPage({ history }) {
  const benefisUIEvents = {
    newBenefisIndividuButtonClick: () => {
      history.push("/_distribution/benefis/individual/new");
    },
    newBenefisOrganizationButtonClick: () => {
      history.push("/_distribution/benefis/organization/new");
    },
    openEditBenefisIndividualPage: id => {
      history.push(`/_distribution/benefis/individual/${id}/edit`);
    },
    openEditBenefisOrganizationPage: id => {
      history.push(`/_distribution/benefis/organization/${id}/edit`);
    },
    openDeleteBenefisPage: id => {
      history.push(`/_distribution/benefis/${id}/delete`);
    },
    openImportBenefisIndividuPage: () => {
      history.push("/_distribution/benefis/import/individual");
    },
    openImportBenefisOrganizationPage: () => {
      history.push("/_distribution/benefis/import/organization");
    }
  };

  return (
    <BenefisUIProvider benefisUIEvents={benefisUIEvents}>
      {/* <PrivateRoute
        role={RoleChecker("Create", "benefis_category")}
        component={BenefisEditDialog}
        path="/_distribution/benefis/new"
      /> */}
      {/* <PrivateRoute
        role={RoleChecker("Edit", "benefis_category")}
        component={BenefisEditDialog}
        path="/_distribution/benefis/:id/edit"
      /> */}
      <PrivateRoute
        role={RoleChecker("Delete", "benefis_category")}
        component={BenefisEditDialog}
        path="/_distribution/benefis/:id/edit"
      />

      {/* <Route path="/_distribution/benefis/new">
        {({ history, match }) => (
          <BenefisEditDialog
            show={match != null}
            onHide={() => {
              history.push("/_distribution/benefis");
            }}
          />
        )}
      </Route> */}
      {/* <Route path="/_distribution/benefis/:id/edit">
        {({ history, match }) => (
          <BenefisEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/_distribution/benefis");
            }}
          />
        )}
      </Route> */}
      <Route path="/_distribution/benefis/:id/delete">
        {({ history, match }) => (
          <BenefisDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/_distribution/benefis");
            }}
          />
        )}
      </Route>

      <BenefisCard />
    </BenefisUIProvider>
  );
}
